import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-creditNote",
  "use": "icon-creditNote-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-creditNote\"><path d=\"M921.6 102.4H102.4C46.08 102.4 0 148.48 0 204.8v614.4c0 56.32 46.08 102.4 102.4 102.4h819.2c56.32 0 102.4-46.08 102.4-102.4V204.8c0-56.32-46.08-102.4-102.4-102.4zM102.4 204.8h819.2v153.6H102.4V204.8zm0 614.4V460.8h819.2v358.4H102.4zm563.2-204.8H768c30.72 0 51.2 20.48 51.2 51.2s-20.48 51.2-51.2 51.2H665.6c-30.72 0-51.2-20.48-51.2-51.2s20.48-51.2 51.2-51.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol